import { useState, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import useAuthStore from '../../store/authStore'
import useOrgStore from '../../store/orgStore'
import { Toaster } from 'react-hot-toast'
import { useLocale } from '../../i18n/LocaleProvider'

const pageTitles = {
  '/dashboard': 'jobs',
  '/dashboard/settings': 'settings',
  '/dashboard/admin': 'admin',
  '/dashboard/help': 'help',
  '/dashboard/billing/success': 'billingSuccess',
}

export function AppLayout() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false)
  const location = useLocation()
  const { user } = useAuthStore()
  const { org, usage, fetchOrg, fetchUsage } = useOrgStore()
  const { t } = useLocale()

  const pageKey = pageTitles[location.pathname] || 'fallback'
  const pageInfo = {
    title: t(`authenticated.app.pages.${pageKey}.title`),
    subtitle: t(`authenticated.app.pages.${pageKey}.subtitle`),
  }

  useEffect(() => {
    fetchOrg()
    fetchUsage()
  }, [])

  useEffect(() => {
    setMobileSidebarOpen(false)
  }, [location.pathname])

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '12px',
            fontSize: '14px',
            fontWeight: '500',
          },
          success: {
            style: {
              background: '#f0fdf4',
              color: '#166534',
              border: '1px solid #bbf7d0',
            },
            iconTheme: {
              primary: '#22c55e',
              secondary: '#f0fdf4',
            },
          },
          error: {
            style: {
              background: '#fef2f2',
              color: '#991b1b',
              border: '1px solid #fecaca',
            },
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fef2f2',
            },
          },
        }}
      />

      {/* Desktop sidebar */}
      <Sidebar />

      {/* Mobile sidebar */}
      {mobileSidebarOpen && (
        <Sidebar
          mobile
          onClose={() => setMobileSidebarOpen(false)}
        />
      )}

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <TopBar
          onMenuClick={() => setMobileSidebarOpen(true)}
          title={pageInfo.title}
          subtitle={pageInfo.subtitle}
        />

        <main className="flex-1 overflow-y-auto">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
